var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHash = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 56 56",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.845 23.333A2.333 2.333 0 0 1 19.178 21h3.5l.725-2.9a2.333 2.333 0 1 1 4.527 1.133L27.488 21h4.523l.725-2.9a2.333 2.333 0 1 1 4.528 1.133L36.822 21H38.5a2.333 2.333 0 1 1 0 4.667h-2.845l-1.166 4.666h1.678a2.333 2.333 0 0 1 0 4.667h-2.845l-.725 2.9a2.333 2.333 0 0 1-4.527-1.133L28.512 35h-4.524l-.724 2.9a2.333 2.333 0 1 1-4.528-1.133L19.178 35H17.5a2.333 2.333 0 1 1 0-4.667h2.845l1.167-4.666h-2.334a2.333 2.333 0 0 1-2.333-2.334Zm9.477 2.334-1.167 4.666h4.523l1.167-4.666h-4.523Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 14a7 7 0 0 1 7-7h28a7 7 0 0 1 7 7v28a7 7 0 0 1-7 7H14a7 7 0 0 1-7-7V14Zm7-2.333A2.333 2.333 0 0 0 11.667 14v28A2.333 2.333 0 0 0 14 44.333h28A2.333 2.333 0 0 0 44.333 42V14A2.333 2.333 0 0 0 42 11.667H14Z",
  fill: "currentColor"
})));
export default SvgHash;